import {ErrorHandler, Provider} from '@angular/core'
import {ConfigService} from '../config/config.service'
import {LocalStorageService} from '../storage/local-storage.service'
import {GlobalErrorHandler} from './global-error-handler.service'
import {TraceService} from '@sentry/angular-ivy'
import {Router} from '@angular/router'

export const provideErrorHandler: () => Provider[] = () => [
  {provide: ErrorHandler, deps: [ConfigService, LocalStorageService], useClass: GlobalErrorHandler},
]

export const provideTracing: () => Provider[] = () => [{provide: TraceService, deps: [Router]}]
